import { Pipe, PipeTransform } from '@angular/core';
import { CmLocalizationService } from '@ats/cm/core';
import { AtsSplitPascalPipe } from '@ats/utility';

@Pipe({
    name: 'cmLocalizeEnum',
    standalone: false
})
export class CmLocalizeEnumPipe implements PipeTransform {
	constructor(private localizationService: CmLocalizationService, private splitPascalPipe: AtsSplitPascalPipe) {}

	transform(value: string, key: string): string {
		if (!key || !value) return '';

		const loc = this.localizationService.findLocalization(`System.Enum.${key}.${value}`, false);

		return (loc || {}).value || this.splitPascalPipe.transform(value);
	}
}
